import Section from '../ui/Section'
import { Display, Body, Points, Accent, Em } from '../ui/Type'

const EXPANSIONS = [
  'One agent becomes one hundred.',
  'A monthly process becomes continuous.',
  'Ten thousand documents become ten million.',
  'A few reasoning steps become hours of autonomous work.',
]

export default function PredictableEconomics() {
  return (
    <Section label="Predictable economics">
      <Display>
        AI usage is unpredictable.
        <br />
        Its economics <Accent>don't have to be.</Accent>
      </Display>

      <Body className="mt-8">An AI workload can expand dramatically as it becomes more useful.</Body>
      <Points className="mt-8" items={EXPANSIONS} />
      <Body className="mt-8">
        LiquidBrain turns that variable demand into <Em>committed intelligence capacity with known economics.</Em>
      </Body>

      {/* The shift in the unit of account, shown rather than described. */}
      <div className="mt-14 border-t border-[var(--line)] pt-8">
        <div className="font-mono text-[11.5px] tracking-[0.14em] text-[var(--faint)] uppercase">From</div>
        <p className="mt-3 font-mono text-[clamp(1rem,1.9vw,1.2rem)] leading-[1.4] text-[var(--muted)] line-through decoration-[var(--line-2)]">
          Tokens × usage × model price
        </p>
        <div className="mt-8 font-mono text-[11.5px] tracking-[0.14em] text-[var(--ink-blue)] uppercase">To</div>
        <p className="mt-3 font-mono text-[clamp(1rem,1.9vw,1.2rem)] leading-[1.4] text-[var(--ink)]">
          Workload + capacity + SLA
        </p>
      </div>

      <Body className="mt-14">Run the intelligence the business needs with economics you can actually plan around.</Body>
    </Section>
  )
}
